import isEmpty from 'lodash/isEmpty';
import isObject from 'lodash/isObject';
import isNull from 'lodash/isNull';
import { FormAttachment } from 'types/appointment';
import { PaginateParamsRequest } from 'types/common';
import { HomePageFormData, HomePageInfo, HomePageResponseViewModel } from 'types/home-page';
import { GooglePlaceAddress } from 'types/user';

export const getTransformedGoogleAddressToRequest = (address: GooglePlaceAddress | null) =>
    isNull(address) ? { address: null, placeId: null } : { address: address.description, placeId: address.placeId };

export const getTransformedGoogleAddressFromResponse = (address: string | null, placeId: string | null) =>
    isNull(address) ? null : { description: address, placeId: placeId || '' };

export const getTransformedAttachmentsToRequest = (attachments: FormAttachment[]) =>
    attachments.length
        ? attachments.map(({ id, file, ...rest }) => ({
              id: id.includes('local-') ? undefined : id,
              ...rest,
          }))
        : null;

export const getTransformedHomePageFormFromResponse = ({
    description,
    attachments,
}: HomePageResponseViewModel): HomePageFormData => ({
    description: isNull(description) ? '' : description,
    attachments: isNull(attachments) ? [] : attachments,
});

export const getTransformedHomePageInfoFromResponse = ({
    description,
    attachments,
}: HomePageResponseViewModel): HomePageInfo => ({
    description,
    images: isNull(attachments) ? [] : attachments.map(({ id, filePath, fileName }) => ({ id, filePath, fileName })),
});

export const getFilteredParamsToRequest = <T extends PaginateParamsRequest>({
    page,
    pageSize,
    sortingOrder,
    ...params
}: T) =>
    params
        ? Object.keys(params).reduce(
              (acc, key) =>
                  isEmpty(params[key as keyof Omit<T, 'page' | 'pageSize' | 'sortingOrder'>])
                      ? acc
                      : { ...acc, [key]: params[key as keyof Omit<T, 'page' | 'pageSize' | 'sortingOrder'>] },
              { page, pageSize, sortingOrder } as T,
          )
        : params;
